export class UserOrganizations {
    numCliente : number;
    nomCompleto : string;
    roleId : number;
    docIdPat : string;

    constructor(numCliente : number, nomCompleto : string, roleId : number, docIdPat : string) {
        this.numCliente = numCliente;
        this.nomCompleto = nomCompleto;
        this.roleId = roleId;
        this.docIdPat = docIdPat;
    }
}